import React from "react";
import {
	ArrowDownRight,
	ArrowUpRight,
	ChevronDown,
	ChevronUp,
	Users,
	Ticket,
} from "tabler-icons-react";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import Charts from "./Charts";
import FeaturedTable from "./FeaturedTable";

function Dashboard() {
	return (
		<div className="w-full">
			<h1 className="mb-3 w-screen md:w-auto text-slate-500 dark:text-darktext px-5 py-2 md:pb-0 uppercase font-semibold border-b border-b-slate-100 dark:border-b-darkborder">
				Dashboard
			</h1>

			{/* STATS */}
			<div className="w-screen md:w-auto flex stats overflow-x-auto justify-between md:justify-start items-center gap-2 md:space-x-5 px-5">
				<div className="border flex-shrink-0 border-slate-100 dark:border-darkborder bg-white dark:bg-darkbg rounded-md shadow-sm px-2 md:px-5 py-2">
					<div className="flex justify-between items-center">
						<span className="uppercase text-slate-500 dark:text-darktext text-xs md:text-sm font-semibold">
							users
						</span>
						<Users className="text-slate-300 dark:text-darktext" />
					</div>
					<div className="flex items-baseline space-x-3 mt-2">
						<span className="font-bold text-xl md:text-2xl">13,456</span>
						<span className="flex text-sm text-green-500">
							34% <ArrowUpRight size={16} />
						</span>
					</div>
					<span className="text-xs md:text-sm text-slate-400 dark:text-darktext">
						Compared to previous month
					</span>
				</div>

				<div className="border flex-shrink-0 border-slate-100 dark:border-darkborder bg-white dark:bg-darkbg rounded-md shadow-sm px-2 md:px-5 py-2">
					<div className="flex justify-between items-center">
						<span className="uppercase text-slate-500 dark:text-darktext text-xs md:text-sm font-semibold">
							events
						</span>
						<Ticket className="text-slate-300 dark:text-darktext" />
					</div>
					<div className="flex items-baseline space-x-3 mt-2">
						<span className="font-bold text-xl md:text-2xl">4,145</span>
						<span className="flex text-sm text-red-500">
							-13% <ArrowDownRight size={16} />
						</span>
					</div>
					<span className="text-xs md:text-sm text-slate-400 dark:text-darktext">
						Compared to previous month
					</span>
				</div>

				<div className="border flex-shrink-0 border-slate-100 dark:border-darkborder bg-white dark:bg-darkbg rounded-md shadow-sm px-2 md:px-5 py-2">
					<div className="flex justify-between items-center">
						<span className="uppercase text-slate-500 dark:text-darktext text-xs md:text-sm font-semibold">
							events
						</span>
						<Ticket className="text-slate-300 dark:text-darktext" />
					</div>
					<div className="flex items-baseline space-x-3 mt-2">
						<span className="font-bold text-xl md:text-2xl">4,145</span>
						<span className="flex text-sm text-red-500">
							-13% <ArrowDownRight size={16} />
						</span>
					</div>
					<span className="text-xs md:text-sm text-slate-400 dark:text-darktext">
						Compared to previous month
					</span>
				</div>
			</div>

			{/* CHARTS */}
			<div className="w-screen md:w-auto flex flex-col md:flex-row mt-3 space-y-4 md:space-y-0 md:space-x-4 px-5">
				{/* Feature */}
				<div className="border border-slate-100 dark:border-darkborder bg-white dark:bg-darkbg rounded-md shadow-sm px-5 py-2 md:w-1/3">
					<span className="text-slate-500 dark:text-darktext">Total Users</span>
					<CircularProgressbar
						className="h-28 w-28 text-slate-500 dark:text-darktext"
						value={70}
						text="70%"
						strokeWidth={5}
					/>
					<div className="flex flex-col text-slate-500 dark:text-darktext text-center my-4 space-y-2">
						<span className="">Total users added today</span>
						<span className="text-3xl text-slate-700 dark:text-darktext font-semibold">
							103
						</span>
					</div>
					<p className="text-sm text-slate-500 dark:text-darktext text-center">
						Previous users processing. Last users to be added may not be
						included
					</p>
					<div className="flex justify-between">
						<span className="flex flex-col items-center text-slate-500 dark:text-darktext text-center mt-2">
							<span>Target</span>
							<span className="flex text-red-500 text-sm items-center py-1">
								<ChevronDown size={15} /> 400
							</span>
						</span>
						<span className="flex flex-col items-center text-slate-500 dark:text-darktext text-center mt-2">
							<span>Last week</span>
							<span className="flex text-green-500 text-sm items-center py-1">
								<ChevronUp size={15} /> 127
							</span>
						</span>
						<span className=" flex flex-col items-center text-slate-500 dark:text-darktext text-center mt-2">
							<span>Last Month</span>
							<span className="flex text-red-500 text-sm items-center py-1">
								<ChevronDown size={15} /> 634
							</span>
						</span>
					</div>
				</div>

				{/* Chart */}
				<Charts />
			</div>

			{/* Featured Table */}
			<div className="px-5 w-screen md:w-auto">
				<FeaturedTable />
			</div>
		</div>
	);
}

export default Dashboard;
